const fr = {
  nav: {
    home: "Accueil", cities: "Villes", simulators: "Simulateurs",
    strategies: "Stratégies", accompagnement: "Accompagnement",
    tagline: "L'immobilier israélien pour les francophones",
  },
  footer: {
    tagline: "Le guide de référence pour investir dans l'immobilier israélien",
    disclaimer: "Les données présentées sur ce site sont indicatives et ne constituent pas un conseil en investissement. Consultez un professionnel avant toute décision.",
    copyright: "©️ 2025 Deal Israel – Tous droits réservés",
  },
};
export default fr;
